(function($) {

    // Services slider 
    $('.slider-services').slick({
        appendDots: '#servicesSliderContainer .pagination-container',
        arrows: true,
        centerMode: true,
        dots: true,
        slide: '.slider-item',
        slidesToScroll: 1,
        slidesToShow: 3,
        variableWidth: true,
        infinite: true,
        cssEase: 'cubic-bezier(0.3, 1, .99, 1)',
        responsive: [
        {
            breakpoint: 992,
            settings: {
                arrows: false,
                centerMode: false,
                infinite: false,
                slidesToScroll: 1,
                slidesToShow: 1,
                variableWidth: false,
            }
        }]
    });

    $('.js-services-toggle').click(function(e) {
        e.preventDefault();
        var sliderGoTo = $(this).data('slide');
        $('.slider-services').slick('slickGoTo', sliderGoTo);
    });

    // go to index slide
    $('.js-slider-index').click(function() {
        $('.slider-services').slick('slickGoTo', 0);
    });

    // toggle indicator button when on any slide except index
    $('.slider-services').on('afterChange', function(event, slick, currentSlide){
        if (currentSlide == 0) {
            $('.js-slider-index').removeClass('is-visible');

            setTimeout(function() { 
                $('.js-slider-index').removeClass('is-active');
            }, 300);
        } else {
            $('.js-slider-index').addClass('is-active');

            setTimeout(function() { 
                $('.js-slider-index').addClass('is-visible');
            }, 300);
        }
    });

})(jQuery);
